import { Confirmation } from "primeng/api";

export const CustomConfirmDialogKey = "confirm-dialog-custom-style-class";

export interface CustomDialogConfirmation extends Confirmation {
    styleClass?: string;
}
